export default initData => {
    return {
        allCategories: initData.allCategories || [],
        breadcrumbs: '',
        canonicalLink: '',
        metaDescription: initData.description || '',
        metaRobots: '',
        metaTitle: initData.title || '',
        blockMetaTitleFromSearchResult: false,
        type: initData.pageName || null
    };
};
